
import React from 'react';
import TokenPackageCard from './TokenPackageCard';
import { TOKEN_PACKAGES } from './constants';

interface TokenPackageListProps {
  loading: string | null;
  onPurchase: (packageId: string) => void;
  formatTokens: (tokens: number) => string;
}

const TokenPackageList: React.FC<TokenPackageListProps> = ({
  loading,
  onPurchase,
  formatTokens
}) => {
  return (
    <div className="space-y-3">
      {TOKEN_PACKAGES.map((pkg) => (
        <TokenPackageCard
          key={pkg.id}
          package={pkg}
          loading={loading}
          onPurchase={onPurchase}
          formatTokens={formatTokens}
        />
      ))}
    </div>
  );
};

export default TokenPackageList;
